export default {
	BANNER_CLICK: 212,
	LIGHT_BOX_OPENED: 213,
	CLICK_ON_SUBMIT_IN_LIGHT_BOX: 214,
	DISCARD_LIGHT_BOX: 215,
	OPEN_PAGE: 129
}

//OPEN_PAGE